import { render, staticRenderFns } from "./Mascota.vue?vue&type=template&id=78f3e1c9&"
import script from "./Mascota.vue?vue&type=script&lang=js&"
export * from "./Mascota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports